var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", margin: "20px 10px" } },
    [
      _vm.showDialog
        ? _c("el-tree", {
            ref: "tree1",
            staticClass: "filter-tree",
            attrs: {
              "render-content": _vm.renderContent,
              "show-checkbox": "",
              "highlight-current": "",
              "node-key": "treeId",
              data: _vm.data,
              props: _vm.defaultProps,
              "filter-node-method": _vm.filterNode
            },
            on: { check: _vm.handleCheck }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handConfirm } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }